if (!customElements.get('influencer-listing')) {
  class InfluencerListing extends HTMLElement {
    constructor() {
      super();
      this.tiles = [];
      this.tileWrapper = null;
      this.voidList = this.dataset.voidList.split(',')
    }
    
    disableUnApplicableLetters(tiles = this.tiles) {
      this.querySelectorAll('[data-action="sort-by-letter"][data-letter]').forEach((el) => {
        const letter = el.dataset.letter;
        if (this.tiles.find((tile) => tile.dataset.articleLetter === letter)) {
          el.removeAttribute('disabled');
          return;
        }
        el.setAttribute('disabled', true);
      })
    }
    
    fetchTiles(i) {
      let pathName = '';
      if (this.querySelector('[data-current-link]')?.href) {
        pathName = new URL(this.querySelector('[data-current-link]')?.href)?.pathname;
      }
      return new Promise((resolve, reject) => {
        fetch(`${pathName}?section_id=influencer-list`)
          .then(response => response.text())
          .then(data => { 
            const temp = document.createElement('div');
            temp.innerHTML = data;
            const tilesToAdd = [...temp.querySelectorAll('intersection-loader')];

            this.tiles = [...tilesToAdd];
          })
          .finally(() => {
            resolve();
          })
          .catch((err) => {
            reject(err)
          });          
      })
    }
    
    updateLetters() {
      this.tiles = [];
        const promises = [];        
        promises.push(this.fetchTiles())
        Promise.all(promises).then(() => {
          this.disableUnApplicableLetters();
        });
    }
    
    connectedCallback() {
      window.addEventListener('globals:fetch-filtered-result', () => {
        this.updateLetters();
      });
      
      document.addEventListener('DOMContentLoaded', () => {
        this.updateLetters();
      });
      
      this.addEventListener('click', (e) => {
        const clickedEl = e.target.closest('[data-action]');
        if (!clickedEl) return;
        
        const {
          action,
          letter
        } = clickedEl.dataset;
        
        const tileWrapper = this.querySelector('[data-append-pagination]');

        switch(action) {
          case 'sort-by-letter':
            this.querySelectorAll('[data-letter].active').forEach((el) => {
              el.classList.remove('active');
              el.setAttribute('aria-pressed', 'false');
            });
            clickedEl.classList.add('active');
            clickedEl.setAttribute('aria-pressed', 'true');
            document.body.classList.add('loading');

            this.tiles = [];
            const promises = [];        
            promises.push(this.fetchTiles())
                    
            Promise.all(promises).then(() => {
              const articlesByLetter = this.tiles.filter((tile) => {
                const articleLetter = tile.dataset.articleLetter;
                return articleLetter === letter; 
              });
              
              tileWrapper.innerHTML = '';
              if (articlesByLetter.length) {
                tileWrapper.append(...articlesByLetter);
              } else {
                tileWrapper.innerHTML = `
                  <div class="col-span-3 text-center p-12">
                    <h2>No matching entries.</h2>
                  </div>
                `;
              }
              this.disableUnApplicableLetters();
              document.body.classList.remove('loading');
            });
          break;
          default: break;
        }
      })
    }
  }

  customElements.define('influencer-listing', InfluencerListing);
}
